<template>
    <div class="second-box" v-if="props.name">
        <div class="mian-info">
            <div v-if="props.from == 'kolinfo'" class="title">达人/KOL“{{ props.name }}”在“{{state.scenceTypeMap[state.type]}}” 推广专用链接</div>
            <div v-else class="title">{{ props.name }}</div>
            <template v-if="state.type == '1'">
                <div class="item">
                    <div class="label">
                        <span>摩点小程序ID</span> 
                        <el-icon class="icon" @click="showDrawer('weixin01')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">wx6a3c68659310e879</div>
                    <el-button 
                        class="copy" 
                        type="primary" 
                        data-clipboard-text="wx6a3c68659310e879" 
                        @click="copy">
                        复制
                    </el-button>
                </div>
                <div class="item">
                    <div class="label">
                        <span>小程序路径</span>
                        <el-icon class="icon" @click="showDrawer('weixin01')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[10] }}</div>
                    <el-button 
                        class="copy"  
                        type="primary"
                        :data-clipboard-text="props.obj[10]"
                        @click="copy" >
                        复制
                    </el-button>
                </div>
                <div class="item">
                    <div class="label">
                        <span>小程序短链</span>
                        <el-icon class="icon" @click="showDrawer('weixin02')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[11] }}</div>
                    <el-button 
                        class="copy" 
                        type="primary"
                        :data-clipboard-text="props.obj[11]" 
                        @click="copy">
                        复制
                    </el-button>
                </div>
                <div class="item item-top">
                    <div class="label">
                        <span>小程序码</span>
                        <el-icon class="icon" @click="showDrawer('weixin04')"><QuestionFilled /></el-icon>
                    </div>
                    <el-image 
                        class="img" 
                        :src="$imgUrlFilter(props.obj[13], 240)"
                        fit="fill"
                        lazy />
                    <el-button class="btn" type="primary" @click="triggerADownload(props.obj[13])">下载</el-button>
                    <p class="tips">生成的小程序码尺寸为1280px*1280px，为确保扫码可识别度，建议实际使用尺寸不小于200px*200px</p>
                </div>
            </template>
            <template v-else-if="state.type == '2'">
                <div class="item">
                    <div class="label">
                        <span>H5链接</span>
                        <el-icon class="icon" @click="showDrawer('weibo')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[20] }}</div>
                    <el-button 
                        type="primary" 
                        class="copy"
                        :data-clipboard-text="props.obj[20]"
                        @click="copy"
                        >复制</el-button>
                </div>
            </template>
            <template v-else-if="state.type == '3'">
                <div class="item">
                    <div class="label">
                        <span>短信链接</span>
                        <el-icon class="icon" @click="showDrawer('sms')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[30] }}</div>
                    <el-button 
                        type="primary" 
                        class="copy"
                        :data-clipboard-text="props.obj[30]"
                        @click="copy">复制</el-button>
                </div>
            </template>
            <template v-else-if="state.type == '4'">
                <div class="item">
                    <div class="label">
                        <span>H5长链接</span> 
                        <el-icon class="icon" @click="showDrawer('other01')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[40] }}</div>
                    <el-button 
                        type="primary" 
                        class="copy"
                        :data-clipboard-text="props.obj[40]"
                        @click="copy">复制</el-button>
                </div>
                <div class="item">
                    <div class="label">
                        <span>H5短链接</span>
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            content="链接有字符长度限制时可使用短链接"
                            placement="top-start"
                            trigger="click"
                        >
                            <el-icon class="icon"><QuestionFilled /></el-icon>
                        </el-tooltip>
                    </div>
                    <div class="link-info">{{ props.obj[41] }}</div>
                    <el-button 
                        class="copy" 
                        type="primary"
                        :data-clipboard-text="props.obj[41]"
                        @click="copy"
                        >复制
                    </el-button>
                </div>
                <div class="item item-top">
                    <div class="label">
                        <span>二维码</span> 
                        <el-icon class="icon" @click="showDrawer('other02')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="img" style="width: 120px; height: 120px; overflow: hidden;">
                        <div ref="qrCodeUrl"></div>
                    </div>
                    <el-button type="primary" class="btn" @click="download">下载</el-button>
                    <p class="tips">生成的二维码尺寸为1280px*1280px，为确保扫码可识别度，建议实际使用尺寸不小于200px*200px</p>
                </div>
            </template>
            <template v-else-if="state.type == '5'">
                <div class="item">
                    <div class="label">
                        <span>H5长链接</span>
                        <el-icon class="icon" @click="showDrawer('weixin03')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[12] }}</div>
                    <el-button 
                        class="copy" 
                        type="primary"
                        :data-clipboard-text="props.obj[12]"
                        @click="copy"
                        >复制
                    </el-button>
                </div>
                <div class="item">
                    <div class="label">
                        <span>H5短链接</span>
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            content="链接有字符长度限制时可使用短链接"
                            placement="top-start"
                            trigger="click"
                        >
                            <el-icon class="icon"><QuestionFilled /></el-icon>
                        </el-tooltip>
                    </div>
                    <div class="link-info">{{ props.obj[14] }}</div>
                    <el-button 
                        class="copy" 
                        type="primary"
                        :data-clipboard-text="props.obj[14]"
                        @click="copy"
                        >复制
                    </el-button>
                </div>
            </template>
            <template v-else-if="state.type == '6'">
                <div class="item">
                    <div class="label">
                        <span>口令</span> 
                        <el-icon class="icon" @click="showDrawer('command')"><QuestionFilled /></el-icon>
                    </div>
                    <div class="link-info">{{ props.obj[42] }}</div>
                    <el-button 
                        type="primary" 
                        class="copy"
                        :data-clipboard-text="props.obj[42]"
                        @click="copy">复制</el-button>
                </div>
            </template>
        </div>
        <el-drawer v-model="state.drawer" :title="state.drawerTitMap[state.drawerType]"
            size="400px">
            <CompDrawer :type="state.drawerType" />
            <template #footer>
                <el-button type="primary" @click="state.drawer = false">确认</el-button>
            </template>
        </el-drawer>
    </div>
</template>

<script setup>
import Clipboard from 'clipboard'
import QRCode from 'qrcodejs2'

import { ref, reactive, computed, defineProps } from "vue";
import { useRoute } from "vue-router";
import { watch } from "@vue/runtime-core";

import CompDrawer from "./drawers.vue";
import { ElMessage } from 'element-plus'
const route = useRoute();

const props = defineProps({
    obj: Object,
    type: [Number, String],
    name: String,
    from: String,
})

const state = reactive({
    drawerTitMap: {
        'weixin01': '“小程序ID”及“小程序路径”使用方法',
        'weixin02': '小程序短链使用方法',
        'weixin03': 'H5链接使用方法',
        'weixin04': '小程序码使用方法',
        'weibo': '微博H5使用方法',
        'sms': '短信短链接使用方法',
        'other01': 'H5链接使用方法',
        'other02': '二维码使用方法',
        'command': '“口令推广链接”使用方法'
    },
    drawer: false,
    drawerType: '1',
    scenceTypeMap: {
        1: '微信小程序',
        2: '微博H5',
        3: '短信',
        4: '通用链接',
        5: '微信H5',
        6: '口令',
    }
})
state.type = computed(() => {
    return route.query.type || props.type
})

const showDrawer = (type) => {
    state.drawerType = type
    state.drawer = true
}

const copy = () => {
    let clipboard = new Clipboard('.copy')
    clipboard.on('success', function(e) {
        e.clearSelection()
        ElMessage({
            type: 'warning',
            message: '复制成功！',
            customClass: 'waring-customize',
        })
        clipboard.destroy()
    })
    clipboard.on('error', function() {
        ElMessage({
            message: '复制失败！',
            customClass: 'info-customize',
            type: 'info',
        })
        clipboard.destroy()
    })
}
// 微博二维码 -- start
const qrCodeUrl = ref(null);
// 生成二维码
const creatQrCode = () => {
    new QRCode(qrCodeUrl.value, {
        text: props.obj[40],
        width: 1280,
        height: 1280,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
    })
}
watch(() => {[qrCodeUrl.value, props.obj[40]]}, () => {
    if (qrCodeUrl.value && props.obj[40]) {
        creatQrCode()
    }
}, { deep: true, immediate: true })
// 微博二维码 -- end

const triggerADownload = (imgsrc) => {
    const a = document.createElement('a');
    a.href = `${imgsrc}?response-content-type=application/octet-stream`;
    a.click();
    a.remove();
}

const download = () => {
    const qrcode = qrCodeUrl.value
    const canvas = qrcode.querySelector('canvas')
    const imgurl = canvas.toDataURL('image/jpeg')
    const a = document.createElement('a')
    a.href = imgurl
    a.download = '二维码' // 图片名称
    a.click()
}
</script>

<style lang="scss" scoped>
.second-box {
    .tit {
        display: flex;
        align-items: center;
        .icon {
            margin: 0 6px;
        }
    }
    .mian-info {
        padding: 20px 20px 104px;
        background-color: #fff;
        border-radius: 8px;
        // margin-top: 20px;
        .title {
            font-size: 20px;
            font-weight: bold;
        } 
        .item {
            display: flex;
            align-items: center;
            margin-top: 20px;
            .label {
                display: flex;
                align-items: center;
                font-size: 16px;
                width: 160px;
                .icon {
                    color: #7F7F7F;
                    font-size: 18px;
                    margin-left: 5px;
                    cursor: pointer;
                }
            }
            .link-info {
                width: 528px;
                height: 40px;
                border: 1px solid #E8E8E8;
                border-radius: 4px;
                margin-right: 20px;
                display: flex;
                align-items: center;
                padding: 0 12px;
                white-space: nowrap;
                overflow-x: scroll;
                &::-webkit-scrollbar { 
                    display: none;
                }
            }
            .img {
                width: 120px;
                height: 120px;
                border: 1px solid #E8E8E8;
                border-radius: 4px;
                margin-right: 20px;
            }
            // 小程序码
            &-top {
                align-items: flex-start;
                position: relative;
                .label {
                    padding-top: 12px;
                }
                .btn {
                    align-self: flex-end;
                }
                .tips {
                    color: #7F7F7F;
                    line-height: 1;
                    position: absolute;
                    left: 160px;
                    bottom: -24px;
                }
            }
        }
    }
}
</style>
